import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly baseUrl = environment.apiUrl;

  private hubConnection: signalR.HubConnection;

  constructor() {
    // this.buildConnection();
    // this.startConnection();
  }

  // private buildConnection() {
  //   this.hubConnection = new signalR.HubConnectionBuilder()
  //     .withUrl(`${this.baseUrl}/notificationHub`, {
  //       skipNegotiation: true,
  //       transport: signalR.HttpTransportType.WebSockets, 
  //       withCredentials: true 
  //     })
  //     .configureLogging(signalR.LogLevel.Information)
  //     .build();
  // }

  buildConnection(providerId: string) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.baseUrl}/notificationHub?providerId=${providerId}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        withCredentials: true
      })
      .configureLogging(signalR.LogLevel.None)
      .build();

    this.startConnection();
  }

  private startConnection() {
    this.hubConnection.start()
      .then(() => console.log('SignalR Connected!'))
      .catch(err => console.error('SignalR Connection Error: ', err));
  }

  public listenForNotifications(callback: (message: any) => void) {
    this.hubConnection.on('ReceiveNotification', callback);
  }

}
